export {
	type ChatNavigation as DialogNavigation,
	ChatTopbar as DialogTopbar,
} from '@/shared/ui/chat/topbar';
